var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 18.3333C4 15.8365 6.22876 13.9999 8.73333 13.9999H15.2667C17.7712 13.9999 20 15.8365 20 18.3333V19.9999C20 20.5522 19.5523 20.9999 19 20.9999C18.4477 20.9999 18 20.5522 18 19.9999V18.3333C18 17.1482 16.8858 15.9999 15.2667 15.9999H8.73333C7.11418 15.9999 6 17.1482 6 18.3333V19.9999C6 20.5522 5.55228 20.9999 5 20.9999C4.44772 20.9999 4 20.5522 4 19.9999V18.3333Z",
    fill: "#0173C6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4.99994C10.6193 4.99994 9.5 6.11923 9.5 7.49994C9.5 8.88065 10.6193 9.99994 12 9.99994C13.3807 9.99994 14.5 8.88065 14.5 7.49994C14.5 6.11923 13.3807 4.99994 12 4.99994ZM7.5 7.49994C7.5 5.01466 9.51472 2.99994 12 2.99994C14.4853 2.99994 16.5 5.01466 16.5 7.49994C16.5 9.98522 14.4853 11.9999 12 11.9999C9.51472 11.9999 7.5 9.98522 7.5 7.49994Z",
    fill: "#0173C6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/ProfileIcon.9de06383.svg";
export { ForwardRef as ReactComponent };